<template>
  <div class="contenedor narrativa-scroll" :id="id_scroll">
    <div class="fondo-narrativa">
      <div class="contenedor-fondo fondo-naranja">
        <picture class="capa">
          <source
            srcset="@/assets/img/narrativa/fondos/fondo-naranja.jpg"
            media="(max-width: 769px)"
          />
          <img
            srcset="@/assets/img/narrativa/fondos/fondo-naranja.jpg"
            alt=""
          />
        </picture>
      </div>
      <div class="contenedor-fondo fondo-azul">
        <picture class="capa">
          <source
            srcset="@/assets/img/narrativa/fondos/fondo-azul.jpg"
            media="(max-width: 769px)"
          />
          <img srcset="@/assets/img/narrativa/fondos/fondo-azul.jpg" alt="" />
        </picture>
      </div>
      <div class="contenedor-fondo fondo-verde">
        <picture class="capa">
          <source
            srcset="@/assets/img/narrativa/fondos/fondo-verde.jpg"
            media="(max-width: 769px)"
          />
          <img srcset="@/assets/img/narrativa/fondos/fondo-verde.jpg" alt="" />
        </picture>
      </div>
      <div class="contenedor-fondo fondo-negro">
        
      </div>
      <div class="contenedor-fondo fondo-mapa">
        <picture class="capa">
          <source
            srcset="@/assets/img/narrativa/fondos/mapa-ilus6.png"
            media="(max-width: 769px)"
          />
          <img srcset="@/assets/img/narrativa/fondos/mapa-ilus6.png" alt="" />
        </picture>
      </div>
      <div class="contenedor-svg">
        <svg class="lienzo">
          <defs>
            <pattern
              id="tubo-pattern"
              patternUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <image
                :href="
                  require('@/assets/img/narrativa/ilustracion_05/tubo-sinplecas.png')
                "
                x="0"
                y="0"
                width="141"
                height="795"
                preserveAspectRatio="xMinYMid slice"
              />
            </pattern>
          </defs>
          <g class="principal">
            <g id="lineas-punteadas"></g>
            <g id="tubos"></g>
          </g>
        </svg>
      </div>
    </div>
    <article>
      <div class="step">
        <div class="cover">
          <div class="cover-gradient">
            <h1 class="cover-title titulo-capitulo">Planeas</h1>
            <h2 class="cover-subtitle subtitulo-capitulo">
              Un capítulo del Ecosistema Nacional Informático de Energía y
              Cambio Climático
            </h2>
          </div>
        </div>
      </div>
      <div class="step" id="bullet-planeta">
        <p class="bullet">
          El nivel de consumo de la sociedad en la que vivimos ya no se puede
          mantener; generamos inmensas cantidades de desechos y, como sabemos,
          la Tierra tiene recursos finitos.
        </p>
      </div>
      <div class="step">
        <p class="bullet">
          La relación entre energía, ambiente y sociedad es muy compleja y
          requiere un análisis desde distintos frentes...
        </p>
      </div>
      <div class="step">
        <p class="bullet">
          ya que atraviesa los sistemas económicos, el transporte, la
          alimentación, el agua y la tierra.
        </p>
      </div>
      <div class="step">
        <p class="bullet">
          Además, las fuentes renovables no son 100% limpias. Por ejemplo, los
          paneles solares, aerogeneradores y baterías se fabrican con
          combustibles fósiles (gas, petróleo y carbón), dependen en gran parte
          de la minería y de elementos difíciles de reciclar.
        </p>
      </div>
      <div class="step">
        <p class="bullet">
          Sin embargo, el impacto ambiental de los combustibles fósiles es mucho
          mayor. En este sentido, las energías renovables son esenciales porque
          en algunos casos pueden sustituirlos, además de ayudarnos a recuperar
          la soberanía energética del país...
        </p>
      </div>
      <div class="step">
        <p class="bullet">
          ... actualmente México importa gran parte de lo que consumimos. Por
          ejemplo durante el 2021 compramos a Estados Unidos y otros países el
          72% del gas natural, 59% de gasolina y 46% de diesel.
        </p>
      </div>
      <div class="step" id="bullet-ciudades">
        <p class="bullet">
          A su vez, no debemos olvidar que millones de personas no tienen acceso
          a servicios energéticos básicos y al mismo tiempo, en México, el 10%
          más rico es responsable de la misma cantidad de emisiones que el 50%
          más pobre.
        </p>
      </div>
      <div class="step">
        <p class="bullet">
          Tanto el sector industrial y de transporte como los estratos de mayor
          consumo son los principales responsables y pueden contribuir al
          ahorrar agua y energía, no obstante es fundamental organizarnos para
          impulsar políticas públicas que generen cambios estructurales.
        </p>
      </div>
      <div class="step">
        <p class="bullet urgente"></p>
      </div>
      <div class="step">
        <p class="bullet">
          Para el análisis de este reto mundial, el Conahcyt pone a disposición
          de la ciudadanía la evidencia científica.
        </p>
      </div>
    </article>
  </div>
</template>
    
  <script >
// Transformaciones
import { quitarLoader, mostrarLoader } from "@/components/_utils.js";

import gsap from "gsap";
import { RoughEase } from "gsap/EasePack";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(RoughEase);
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "ExpInicio",
  data() {
    return {
      cantidad_de_archivos_cargados: 0,
      tamanio_pantalla: "escritorio",
      id_scroll: "id-scroll-narrativa",
      escenas: {
        escena_00: [
          {
            alias: "agua",
            ruta: require("@/assets/img/narrativa/ilustracion_01/planeas-1-01.png"),
            x_porc: { escritorio: 0.05, movil: 0.05 },
            y_porc: { escritorio: 0.12, movil: 0.3 },
          },
          {
            alias: "fabrica",
            ruta: require("@/assets/img/narrativa/ilustracion_01/planeas-1-02.png"),
            x_porc: { escritorio: 0.35, movil: 0.1 },
            y_porc: { escritorio: 0.09, movil: 0.08 },
          },
          {
            alias: "coches",
            ruta: require("@/assets/img/narrativa/ilustracion_01/03.png"),
            x_porc: { escritorio: 0.35, movil: 0.5 },
            y_porc: { escritorio: 0.38, movil: 0.25 },
          },
          {
            alias: "barco",
            ruta: require("@/assets/img/narrativa/ilustracion_01/04.png"),
            x_porc: { escritorio: 0.08, movil: 0.08 },
            y_porc: { escritorio: 0.55, movil: 0.55 },
          },
          {
            alias: "tractor",
            ruta: require("@/assets/img/narrativa/ilustracion_01/05.png"),
            x_porc: { escritorio: 0.65, movil: 0.55 },
            y_porc: { escritorio: 0.4, movil: 0.35 },
          },
        ],
        escena_01: [
          {
            alias: "planeta",
            ruta: require("@/assets/img/narrativa/ilustracion_02/2.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 1.5, movil: 1.5 },
          },
          {
            alias: "planeta_lineas_1",
            ruta: require("@/assets/img/narrativa/ilustracion_02/3.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 1.5, movil: 1.5 },
          },
          {
            alias: "planeta_lineas_2",
            ruta: require("@/assets/img/narrativa/ilustracion_02/4.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 1.5, movil: 1.5 },
          },
        ],
        escena_02: [
          {
            alias: "energia",
            ruta: require("@/assets/img/narrativa/ilustracion_03/ENERGIA.gif"),
            x_porc: { escritorio: 0.03, movil: 0.45 },
            y_porc: { escritorio: 2.4, movil: 2.25 },
          },
          {
            alias: "ambiente",
            ruta: require("@/assets/img/narrativa/ilustracion_03/MEDIO AMBIENTE.gif"),
            x_porc: { escritorio: 0.365, movil: 0.05 },
            y_porc: { escritorio: 2.55, movil: 2.55 },
          },
          {
            alias: "sociedad",
            ruta: require("@/assets/img/narrativa/ilustracion_03/SOCIEDAD.gif"),
            x_porc: { escritorio: 0.75, movil: 0.45 },
            y_porc: { escritorio: 2.4, movil: 2.75 },
          },
        ],
        escena_03: [
          {
            alias: "alimentos",
            ruta: require("@/assets/img/narrativa/ilustracion_04/ALIMENTOS.png"),
            x_porc: { escritorio: 0.2, movil: 0.05 },
            y_porc: { escritorio: 2.7, movil: 2.18 },
          },
          {
            alias: "economia",
            ruta: require("@/assets/img/narrativa/ilustracion_04/ECONOMIA.png"),
            x_porc: { escritorio: 0.3, movil: 0.6 },
            y_porc: { escritorio: 2.1, movil: 2.55 },
          },
          {
            alias: "transporte",
            ruta: require("@/assets/img/narrativa/ilustracion_04/TRANSPORTE.png"),
            x_porc: { escritorio: 0.7, movil: 0.01 },
            y_porc: { escritorio: 2.78, movil: 2.8 },
          },
        ],
        escena_04: [
          {
            alias: "tubo",
            ruta: require("@/assets/img/narrativa/ilustracion_05/tubo-sinplecas.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.5, movil: 3.5 },
          },
          {
            alias: "tubo",
            ruta: require("@/assets/img/narrativa/ilustracion_05/tubo-sinplecas.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.5, movil: 3.5 },
          },
          {
            alias: "tubo",
            ruta: require("@/assets/img/narrativa/ilustracion_05/tubo-sinplecas.png"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.5, movil: 3.5 },
          },
          {
            alias: "celdas",
            ruta: require("@/assets/img/narrativa/ilustracion_05/celdas.gif"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },
          {
            alias: "energiaeolica",
            ruta: require("@/assets/img/narrativa/ilustracion_05/energiaeolica.gif"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },
          {
            alias: "pilas",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pilas.gif"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },
          {
            alias: "bombas",
            ruta: require("@/assets/img/narrativa/ilustracion_05/bombas.gif"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "barriles",
            ruta: require("@/assets/img/narrativa/ilustracion_05/barriles.gif"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "mina",
            ruta: require("@/assets/img/narrativa/ilustracion_05/mina.gif"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pleca-azul.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },

          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pleca-azul.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },

          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pleca-azul.png"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },

          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pleca-azul.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pleca-azul.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_05/pleca-azul.png"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
        ],
        escena_05: [],
        escena_06: [
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_07/plecaamarilla.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },

          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_07/plecarosa.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_07/plecaazul.png"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.35, movil: 3.35 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_07/plecaamarilla.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_07/plecarosa.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "pleca",
            ruta: require("@/assets/img/narrativa/ilustracion_07/plecaazul.png"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 3.65, movil: 3.65 },
          },
          {
            alias: "gasnatural",
            ruta: require("@/assets/img/narrativa/ilustracion_07/gasnatural.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: 4.79, movil: 4.79 },
          },
          {
            alias: "bombagasolina",
            ruta: require("@/assets/img/narrativa/ilustracion_07/bombagasolina.png"),
            x_porc: { escritorio: 0.5, movil: 0.5 },
            y_porc: { escritorio: 4.79, movil: 4.79 },
          },
          {
            alias: "pistolagas",
            ruta: require("@/assets/img/narrativa/ilustracion_07/pistolagas.png"),
            x_porc: { escritorio: 0.8, movil: 0.8 },
            y_porc: { escritorio: 4.79, movil: 4.79 },
          },
          {
            alias: "flecha",
            ruta: require("@/assets/img/narrativa/ilustracion_07/flecha1izq.png"),
            x_porc: { escritorio: 0.05, movil: 0.05 },
            y_porc: { escritorio: 4.3, movil: 4.3 },
          },
          {
            alias: "flecha",
            ruta: require("@/assets/img/narrativa/ilustracion_07/flecha2izq.png"),
            x_porc: { escritorio: 0.06, movil: 0.06 },
            y_porc: { escritorio: 4.5, movil: 4.5 },
          },
          {
            alias: "flecha",
            ruta: require("@/assets/img/narrativa/ilustracion_07/flecha3izq.png"),
            x_porc: { escritorio: 0.12, movil: 0.12 },
            y_porc: { escritorio: 4.7, movil: 4.7 },
          },
          {
            alias: "flecha",
            ruta: require("@/assets/img/narrativa/ilustracion_07/flecha1der.png"),
            x_porc: { escritorio: 0.95, movil: 0.95 },
            y_porc: { escritorio: 4.3, movil: 4.3 },
          },
          {
            alias: "flecha",
            ruta: require("@/assets/img/narrativa/ilustracion_07/flechader2.png"),
            x_porc: { escritorio: 0.92, movil: 0.92 },
            y_porc: { escritorio: 4.5, movil: 4.5 },
          },
          {
            alias: "flecha",
            ruta: require("@/assets/img/narrativa/ilustracion_07/flechader3.png"),
            x_porc: { escritorio: 0.88, movil: 0.88 },
            y_porc: { escritorio: 4.7, movil: 4.7 },
          },
        ],
        escena_07: [
          {
            alias: "edificios",
            ruta: require("@/assets/img/narrativa/ilustracion_08/edificios.png"),
            x_porc: { escritorio: 0.1, movil: -0.35 },
            y_porc: { escritorio: 5.5, movil: 5.6 },
          },
          {
            alias: "edificios",
            ruta: require("@/assets/img/narrativa/ilustracion_08/lucesedificios.png"),
            x_porc: { escritorio: 0.1, movil: -0.35 },
            y_porc: { escritorio: 5.5, movil: 5.6 },
          },
          {
            alias: "casitas",
            ruta: require("@/assets/img/narrativa/ilustracion_08/casitas.png"),
            x_porc: { escritorio: 0.1, movil: -0.35 },
            y_porc: { escritorio: 5.5, movil: 5.6 },
          },
          {
            alias: "casitas",
            ruta: require("@/assets/img/narrativa/ilustracion_08/lucescasitas.png"),
            x_porc: { escritorio: 0.1, movil: -0.35 },
            y_porc: { escritorio: 5.5, movil: 5.6 },
          },
          {
            alias: "helicoptero",
            ruta: require("@/assets/img/narrativa/ilustracion_08/helicoptero.gif"),
            x_porc: { escritorio: 0.33, movil: 0.3 },
            y_porc: { escritorio: 5.2, movil: 5.2 },
          },
        ],
        escena_08: [
          {
            alias: "fabrica",
            ruta: require("@/assets/img/narrativa/ilustracion_09/planeas_9_0.png"),
            x_porc: { escritorio: 0.48, movil: 0.4 },
            y_porc: { escritorio: 6.6, movil: 6.45 },
          },
          {
            alias: "fabrica",
            ruta: require("@/assets/img/narrativa/ilustracion_09/planeas_9_1.png"),
            x_porc: { escritorio: 0.15, movil: 0.1 },
            y_porc: { escritorio: 6.65, movil: 6.6 },
          },
          {
            alias: "jet",
            ruta: require("@/assets/img/narrativa/ilustracion_09/planeas_9_3.png"),
            x_porc: { escritorio: 0.05, movil: 0.05 },
            y_porc: { escritorio: 6.6, movil: 6.7 },
          },
          {
            alias: "camioneta",
            ruta: require("@/assets/img/narrativa/ilustracion_09/planeas_9_2.png"),
            x_porc: { escritorio: 0.59, movil: 0.54 },
            y_porc: { escritorio: 6.55, movil: 6.65 },
          },
          {
            alias: "brazo",
            ruta: require("@/assets/img/narrativa/ilustracion_09/planeas_9_4.png"),
            x_porc: { escritorio: 0.5, movil: 0.25 },
            y_porc: { escritorio: 6.52, movil: 6.65 },
          },
        ],
        escena_10: [
          // En este bullet todo es relativo al techo
          {
            alias: "hierba",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_0.png"),
            x_porc: { escritorio: 0.2, movil: 0.2 },
            y_porc: { escritorio: -1.2, movil: -1.2 },
          },
          {
            alias: "bambu",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_1.png"),
            x_porc: { escritorio: 0.1, movil: -0.13 },
            y_porc: { escritorio: -0.8, movil: -0.8 },
          },
          {
            alias: "planta_1",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_2.png"),
            x_porc: { escritorio: 0.03, movil: 0.03 },
            y_porc: { escritorio: -1, movil: 1 },
          },
          {
            alias: "persona",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_3.png"),
            x_porc: { escritorio: 0.1, movil: 0.1 },
            y_porc: { escritorio: -1.2, movil: -1.2 },
          },
          {
            alias: "eolico",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_5.png"),
            x_porc: { escritorio: 0.75, movil: 0.65 },
            y_porc: { escritorio: -1.1, movil: -0.8 },
          },
          {
            alias: "presa",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_4.png"),
            x_porc: { escritorio: 0.18, movil: -0.13 },
            y_porc: { escritorio: -0.45, movil: -0.0 },
          },
          {
            alias: "techo",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_6.png"),
            x_porc: { escritorio: 0.1, movil: 0.1 },
            y_porc: { escritorio: 10.5, movil: 10.3 },
          },
          {
            alias: "grafica",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_7.png"),
            x_porc: { escritorio: 0.37, movil: 0.27 },
            y_porc: { escritorio: 0.3, movil: 1.9 },
          },
          {
            alias: "calentador",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_8.png"),
            x_porc: { escritorio: 0.22, movil: 0.0 },
            y_porc: { escritorio: 0.2, movil: 0.8 },
          },
          {
            alias: "planta_2",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_9.png"),
            x_porc: { escritorio: 0.05, movil: 0.05 },
            y_porc: { escritorio: 0.25, movil: 2 },
          },
          {
            alias: "señor",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_10.png"),
            x_porc: { escritorio: 0.05, movil: 0.05 },
            y_porc: { escritorio: 0.3, movil: 2 },
          },
          {
            alias: "señora",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_11.png"),
            x_porc: { escritorio: 0.19, movil: 0.19 },
            y_porc: { escritorio: 0.2, movil: 2 },
          },
          {
            alias: "fogon",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_12.png"),
            x_porc: { escritorio: 0.57, movil: 0.35 },
            y_porc: { escritorio: -0.9, movil: -0.05 },
          },
          {
            alias: "panel",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_13.png"),
            x_porc: { escritorio: 0.63, movil: 0.6 },
            y_porc: { escritorio: 0.2, movil: 0.8 },
          },
          {
            alias: "bici",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_14.png"),
            x_porc: { escritorio: 0.75, movil: 0.55 },
            y_porc: { escritorio: -0.05, movil: 2 },
          },
          {
            alias: "planta_3",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_15.png"),
            x_porc: { escritorio: 0.2, movil: 0.05 },
            y_porc: { escritorio: 0.8, movil: 1.5 },
          },
          {
            alias: "leña",
            ruta: require("@/assets/img/narrativa/ilustracion_10/planeas_10_16.png"),
            x_porc: { escritorio: 0.39, movil: 0.3 },
            y_porc: { escritorio: 0.45, movil: 1.45 },
          },
        ],
      },
      coordenadas_linea_escritorio: [
        [0.95, 0.0],
        [0.95, 0.2],
        [0.05, 0.2],
        [0.05, 0.7],
        [0.9, 0.7],

        [0.9, 1.2],
        [0.05, 1.8],

        [0.05, 2.453],
        [0.33, 2.453],
        [0.33, 2.6],
        [0.56, 2.6],
        [0.56, 2.75],
        [0.72, 2.75],
        [0.72, 2.453],
        [0.95, 2.453],

        [0.95, 3.5],
        [0.05, 3.5],

        [0.05, 4.35],
        [0.95, 4.35],
        [0.95, 4.65],
        [0.05, 4.65],

        [0.05, 5.5],
        [0.95, 5.5],

        [0.95, 6.5],
        [0.05, 6.5],
        [0.05, 7],
      ],
      coordenadas_linea_movil: [
        [0.05, 0.0],
        [0.05, 0.2],
        [0.95, 0.2],
        [0.95, 0.65],
        [0.1, 0.65],

        [0.1, 1.2],
        [0.9, 1.8],

        [0.9, 2.35],
        [0.1, 2.35],
        [0.1, 2.64],
        [0.5, 2.64],
        [0.5, 2.83],
        [0.95, 2.83],
        

        [0.95, 3.5],
        [0.05, 3.5],

        [0.05, 4.35],
        [0.95, 4.35],
        [0.95, 4.65],
        [0.05, 4.65],

        [0.05, 5.5],
        [0.95, 5.5],

        [0.95, 6.5],
        [0.05, 6.5],
        [0.05, 7],
      ],
      coord_path_punteado_1_escritorio: [
        [0.055, 2.453],
        [0.05, 2.453],
        [0.05, 2.853],
        [0.05, 2.9],
        [0.2, 2.9],
        [0.2, 2.853],
        [0.24, 2.853],
        [0.56, 2.853],
        [0.56, 2.653],
        [0.78, 2.653],
        [0.78, 2.853],
      ],
      coord_path_punteado_1_movil: [
        [0.67, 2.6],
        [0.67, 2.35],
        [0.15, 2.35],
        [0.15, 2.22],
      ],
      coord_path_punteado_2_escritorio: [
        [0.45, 2.853],
        [0.45, 2.9],
        [0.6, 2.9],
        [0.6, 2.8],
        [0.7, 2.8],
      ],
      coord_path_punteado_2_movil: [
      [0.15, 2.22],
      [0.15, 2.65],
      [0.7, 2.65],
      [0.7, 2.83],
              
      ],
      coord_path_punteado_3_escritorio: [
        [0.055, 2.453],
        [0.3, 2.453],
        [0.3, 2.2],
        [0.7, 2.2],
        [0.7, 2.4],
        [0.85, 2.4],
        [0.85, 2.5],
        [0.93, 2.5],
        [0.93, 2.9],
        [1, 2.9],
      ],
      coord_path_punteado_3_movil: [
      [0.2, 2.65],
        [0.2, 2.83],
        [0.7, 2.83],  

      ],

      tamanios: {
        ancho: window.innerWidth,
        alto: window.innerHeight,
      },
      seccion_actual: 0,
      ancho_disenio: 1683,
      altura_disenio: 795,
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.escroleando);
    window.removeEventListener("resize", this.reescalado);
  },
  mounted() {

    mostrarLoader();

    this.cantidad_de_archivos_por_cargar = Object.keys(this.escenas)
      .map((key) => this.escenas[key].length)
      .reduce((accumulator, value) => {
        return accumulator + value;
      }, 0);

    this.tamanio_pantalla = 768 < window.innerWidth ? "escritorio" : "movil";

    this.steps = document
      .querySelector(`#${this.id_scroll}`)
      .querySelectorAll(".step");

    // Lienzo
    this.lienzo = document.querySelector("svg.lienzo");
    this.lienzo.style.opacity = 0;
    this.grupo_principal = this.lienzo.querySelector("g.principal");
    this.configurandoDimensionesLienzo();

    // Mecha
    this.mecha = document.createElementNS("http://www.w3.org/2000/svg", "path");
    this.grupo_principal.prepend(this.mecha);
    this.configurandoMecha();

    //Lineas punteadas
    this.punteada_1 = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    this.grupo_principal
      .querySelector("g#lineas-punteadas")
      .append(this.punteada_1);

    this.punteada_2 = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    this.grupo_principal
      .querySelector("g#lineas-punteadas")
      .append(this.punteada_2);

    this.punteada_3 = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    this.grupo_principal
      .querySelector("g#lineas-punteadas")
      .append(this.punteada_3);

    this.configurandoLineasPunteadas();

    // Tubos
    this.tubos = [
      document.createElementNS("http://www.w3.org/2000/svg", "rect"),
      document.createElementNS("http://www.w3.org/2000/svg", "rect"),
      document.createElementNS("http://www.w3.org/2000/svg", "rect"),
    ];

    for (var i = 0; i < 3; i++) {
      this.grupo_principal.querySelector("g#tubos").append(this.tubos[i]);
      this.tubos[i].setAttribute("fill", "url(#tubo-pattern)");
    }

    this.configurandoTubos();
    // Capas
    for (var escena in this.escenas) {
      this.escenas[escena].forEach((d) => {
        d.image = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "image"
        );
        d.image.setAttributeNS("http://www.w3.org/1999/xlink", "href", d.ruta);

        d.img = document.createElement("img");
        d.img.onload = () => {
          d.ancho_original = d.img.width;
          d.alto_original = d.img.height;
          this.configurandoCapas();
          this.cantidad_de_archivos_cargados += 1;
          if (
            this.cantidad_de_archivos_cargados ==
            this.cantidad_de_archivos_por_cargar
          ) {
            quitarLoader();
            this.lienzo.style.opacity = 1;

          }
        };

        d.img.src = d.ruta;

        this.grupo_principal.append(d.image);
      });
    }

    // Txt porcentajes
    this.txt_porcentaje_amarillo = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "text"
    );
    this.txt_porcentaje_amarillo.innerHTML = "72%";
    this.txt_porcentaje_amarillo.style.textAnchor = "middle";
    this.txt_porcentaje_amarillo.style.dominantBaseline = "text-after-edge";
    this.txt_porcentaje_amarillo.style.fontWeight = "700";
    this.txt_porcentaje_amarillo.style.fill = "#545353";

    this.grupo_principal.append(this.txt_porcentaje_amarillo);

    this.txt_porcentaje_rosa = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "text"
    );
    this.txt_porcentaje_rosa.innerHTML = "59%";
    this.txt_porcentaje_rosa.style.textAnchor = "middle";
    this.txt_porcentaje_rosa.style.dominantBaseline = "text-after-edge";
    this.txt_porcentaje_rosa.style.fontWeight = "700";
    this.txt_porcentaje_rosa.style.fill = "#545353";
    this.grupo_principal.append(this.txt_porcentaje_rosa);

    this.txt_porcentaje_azul = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "text"
    );
    this.txt_porcentaje_azul.innerHTML = "46%";
    this.txt_porcentaje_azul.style.textAnchor = "middle";
    this.txt_porcentaje_azul.style.dominantBaseline = "text-after-edge";
    this.txt_porcentaje_azul.style.fontWeight = "700";
    this.txt_porcentaje_azul.style.fill = "#545353";
    this.grupo_principal.append(this.txt_porcentaje_azul);

    window.addEventListener("scroll", this.escroleando);
    window.addEventListener("resize", this.reescalado);
    // Transicion al cargar
    this.mecha.setAttribute(
      "stroke-dasharray",
      `${this.mecha.getTotalLength()} ${this.mecha.getTotalLength()}`
    );

    this.mecha.setAttribute("stroke-dashoffset", -this.mecha.getTotalLength());

    gsap.to(this.mecha, {
      duration: "2",
      attr: {
        "stroke-dashoffset": 0,
      },
    });
  },
  methods: {
    bullet00() {
      /**
       * Bullet inicial. Los mosaicos deben entrar de los lados al centro, se traza la mecha
       */

      this.escenas.escena_00.forEach((d) => {
        gsap.to(d.image, {
          duration: "1",
          attr: {
            x: d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho,
            opacity: 1,
            y: d.y_porc[this.tamanio_pantalla] * this.tamanios.alto,
            width:
              d.ancho_frac *
              this.tamanios.ancho *
              (this.tamanio_pantalla == "escritorio" ? 1 : 1.5),
            height:
              d.alto_frac *
              this.tamanios.ancho *
              (this.tamanio_pantalla == "escritorio" ? 1 : 1.5),
          },
        });
      });

      
    },
    bullet01() {
      //Salida bullet 00
      this.escenas.escena_00.forEach((d) => {
        gsap.to(d.image, {
          duration: ".5",
          delay: gsap.utils.random([0.1, 0.2, 0.3, 0.4]),
          attr: {
            x: this.tamanios.ancho * 0.5,
            y: 1.5 * this.tamanios.alto,
            opacity: 0,
            width: 0,
            height: 0,
          },
        });
      });
      // Entrada bullet 01
      this.escenas.escena_01.forEach((d) => {
        if (d.alias == "planeta") {
          gsap.to(d.image, {
            delay: 0.3,
            duration: "1",
            attr: {
              opacity: 1,
            },
          });
        } else if (d.alias == "planeta_lineas_1") {
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
          gsap.to(d.image, {
            duration: "1.5",
            repeat: -1,
            yoyo: true,
            ease: "rough({ template: none.out, strength: 1, points: 20, taper: none, randomize: true, clamp: false})",
            attr: {
              opacity: 1,
            },
            scrollTrigger: {
              trigger: "#bullet-planeta",
              start: "top bottom",
              toggleActions: "play pause play pause",
            },
          });
        } else if (d.alias == "planeta_lineas_2") {
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
          gsap.to(d.image, {
            duration: "1",
            repeat: -1,
            //yoyo: true,
            ease: "rough({ template: none.in, strength: 0.2, points: 50, taper: none, randomize: true, clamp: false})",
            attr: {
              opacity: 1,
            },
            scrollTrigger: {
              trigger: "#bullet-planeta",
              start: "top bottom",
              toggleActions: "play pause play pause",
            },
          });
        }
      });

      gsap.to(document.querySelector("div.contenedor-fondo.fondo-naranja"), {
        duration: ".25",
        opacity: 1,
      });
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-azul"), {
        duration: ".25",
        opacity: 0,
      });

      this.escenas.escena_02.forEach((d) => {
        gsap.to(d.image, {
          duration: "1",
          attr: {
            y: (d.y_porc[this.tamanio_pantalla] + 1) * this.tamanios.alto,
          },
        });
      });
    },
    bullet02() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-naranja"), {
        duration: ".25",
        opacity: 0,
      });
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-azul"), {
        duration: ".25",
        opacity: 1,
      });

      this.escenas.escena_02.forEach((d, i) => {
        gsap.to(d.image, {
          delay: i * 0.5,
          duration: "1",
          attr: {
            y:
              d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
              0.5 * d.alto_frac * this.tamanios.ancho,
          },
        });
      });

      this.escenas.escena_03.forEach((d, i) => {
        gsap.to(d.image, {
          duration: ".5",
          attr: {
            opacity: "0",
          },
        });
      });
      // Líneas

      // TRansicion punteada_1
      var dashing = "3, 3";
      var totalLength = this.punteada_1.getTotalLength();

      gsap.to(this.punteada_1, {
        duration: "1",
        attr: {
          "stroke-dashoffset": totalLength,
        },
      });

      // Transicion punteada_2
      totalLength = this.punteada_2.getTotalLength();

      gsap.to(this.punteada_2, {
        duration: "2",
        attr: {
          "stroke-dashoffset": totalLength,
        },
      });

      // Transicion punteada_3
      totalLength = this.punteada_3.getTotalLength();
      gsap.to(this.punteada_3, {
        duration: "2",
        attr: {
          "stroke-dashoffset": totalLength,
        },
      });
    },
    bullet03() {
      this.escenas.escena_03.forEach((d, i) => {
        gsap.to(d.image, {
          delay: i == 1 ? 0.5 : i == 2 ? 2 : 1,
          duration: ".5",
          attr: {
            opacity: "1",
          },
        });
      });
      // Transicion punteada_1
      var dashing = "3, 3";
      var totalLength = this.punteada_1.getTotalLength();
      var dashLength = dashing
        .split(/[\s,]/)
        .map(function (a) {
          return parseFloat(a) || 0;
        })
        .reduce(function (a, b) {
          return a + b;
        });

      var dashCount = Math.ceil(totalLength / dashLength);
      var newDashes = new Array(dashCount).join(dashing + " ");
      var dashArray = newDashes + " 0, " + totalLength;

      this.punteada_1.setAttribute("stroke-dashoffset", totalLength);
      this.punteada_1.setAttribute("stroke-dasharray", dashArray);

      gsap.to(this.punteada_1, {
        delay: 0.5,
        duration: "2",
        attr: {
          "stroke-dashoffset": "0",
        },
      });

      // Transicion punteada_2
      totalLength = this.punteada_2.getTotalLength();
      dashLength = dashing
        .split(/[\s,]/)
        .map(function (a) {
          return parseFloat(a) || 0;
        })
        .reduce(function (a, b) {
          return a + b;
        });

      dashCount = Math.ceil(totalLength / dashLength);
      newDashes = new Array(dashCount).join(dashing + " ");
      dashArray = newDashes + " 0, " + totalLength;

      this.punteada_2.setAttribute("stroke-dashoffset", totalLength);
      this.punteada_2.setAttribute("stroke-dasharray", dashArray);

      gsap.to(this.punteada_2, {
        duration: "2",
        delay: 1,
        attr: {
          "stroke-dashoffset": "0",
        },
      });

      // Transicion punteada_3
      totalLength = this.punteada_3.getTotalLength();
      dashLength = dashing
        .split(/[\s,]/)
        .map(function (a) {
          return parseFloat(a) || 0;
        })
        .reduce(function (a, b) {
          return a + b;
        });

      dashCount = Math.ceil(totalLength / dashLength);
      newDashes = new Array(dashCount).join(dashing + " ");
      dashArray = newDashes + " 0, " + totalLength;

      this.punteada_3.setAttribute("stroke-dashoffset", totalLength);
      this.punteada_3.setAttribute("stroke-dasharray", dashArray);

      gsap.to(this.punteada_3, {
        duration: "2",
        attr: {
          "stroke-dashoffset": "0",
        },
      });
    },
    bullet04() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-mapa"), {
        duration: ".25",
        opacity: 0,
      });
      // ilus de 2 y 3
      this.escenas.escena_02.forEach((d, i) => {
        d.image.setAttribute(
          "y",
          d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
            0.5 * d.alto_frac * this.tamanios.ancho
        );
      });
      // Bullet 04

      this.escenas.escena_04.forEach((d, i) => {
        if (d.alias == "tubo") {
          this.tubos[i].setAttribute("height", 0);
          this.tubos[i].setAttribute(
            "y",
            d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
          );
          gsap.to(document.querySelector("#tubo-pattern"), {
            duration: "1.5",
            attr: {
              height: this.alto_tubo_pattern_image / (0.3 * this.tamanios.alto),
            },
          });

          gsap.to(this.tubos[i], {
            duration: ".5",
            delay: 0.5 + (i % 3) * 0.5,
            attr: {
              height: 0.3 * this.tamanios.alto,
              y:
                (d.y_porc[this.tamanio_pantalla] - 0.5 * 0.3) *
                this.tamanios.alto,
            },
          });
        } else if (d.alias == "pleca") {
          d.image.setAttribute("y", 3.5 * this.tamanios.alto);

          if (i % 3 == 0) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 0.5,
              attr: {
                y:
                  (d.y_porc[this.tamanio_pantalla] - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
              },
            });
          } else if (i % 3 == 1) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1,
              attr: {
                y:
                  (d.y_porc[this.tamanio_pantalla] - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
              },
            });
          } else if (i % 3 == 2) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1.5,
              attr: {
                y:
                  (d.y_porc[this.tamanio_pantalla] - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
              },
            });
          }
        } else {
          d.image.setAttribute("opacity", 0);

          gsap.to(d.image, {
            delay: 0.5 + (i % 3) * 0.5,
            duration: "1",
            attr: {
              opacity: 1,
            },
          });
        }
      });
    },
    bullet05() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-mapa"), {
        duration: ".25",
        opacity: 1,
      });
      gsap.to(this.txt_porcentaje_amarillo, {
        duration: ".5",
        attr: {
          opacity: 0,
        },
      });
      gsap.to(this.txt_porcentaje_rosa, {
        duration: ".5",
        attr: {
          opacity: 0,
        },
      });
      gsap.to(this.txt_porcentaje_azul, {
        duration: ".5",
        attr: {
          opacity: 0,
        },
      });

      gsap.to(document.querySelector("#tubo-pattern"), {
        duration: ".5",
        attr: {
          height: this.alto_tubo_pattern_image / this.tamanios.alto,
        },
      });

      this.escenas.escena_04.forEach((d, i) => {
        if (d.alias == "tubo") {
          //this.tubos[i].setAttribute("height", 0);
          //this.tubos[i].setAttribute("y", 50 + 4 * this.tamanios.alto);

          gsap.to(this.tubos[i], {
            duration: ".5",
            delay: 0.5 + (i % 3) * 0.5,
            attr: {
              y: 50 + 4 * this.tamanios.alto,
              height: this.tamanios.alto,
            },
          });
        } else if (d.alias == "pleca") {
          if (i % 3 == 0) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 0.5,
              attr: {
                opacity: 1,
                y:
                  ((i % 2 == 1 ? 4.3 : 4.7) - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
              },
            });
          } else if (i % 3 == 1) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1,
              attr: {
                opacity: 1,
                y:
                  ((i % 2 == 1 ? 4.3 : 4.7) - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
              },
            });
          } else if (i % 3 == 2) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1.5,
              attr: {
                opacity: 1,
                y:
                  ((i % 2 == 1 ? 4.3 : 4.7) - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
              },
            });
          }
        }
      });
      this.escenas.escena_06.forEach((d, i) => {
        if (d.alias == "pleca") {
          if (i % 3 == 0) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 0.5,
              attr: {
                y:
                  ((i % 2 == 1 ? 4.3 : 4.7) - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 0,
              },
            });
          } else if (i % 3 == 1) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1,
              attr: {
                y:
                  ((i % 2 == 1 ? 4.3 : 4.7) - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 0,
              },
            });
          } else if (i % 3 == 2) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1.5,
              attr: {
                y:
                  ((i % 2 == 1 ? 4.3 : 4.7) - 0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 0,
              },
            });
          }
        } else if (d.alias == "flecha") {
          var angs = [-30, 45, 90];

          gsap.to(d.image, {
            duration: ".5",
            attr: {
              opacity: 0,
              x: this.tamanios.ancho * (parseInt((i - 9) / 3) < 1 ? -0.2 : 1.2),
              y: this.tamanios.alto * (3.75 + 0.75 * (i % 3)),
              transform: `rotate(
            ${(parseInt((i - 9) / 3) < 1 ? -1 : 1) * angs[i % 3]} 
            ${d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho} 
            ${
              this.tamanios.alto *
              (d.y_porc[this.tamanio_pantalla] + (i % 3 == 0 ? d.alto_frac : 0))
            }
          )`,
            },
          });
        } else if (d.alias != "pleca" && d.alias != "flecha") {
          gsap.to(d.image, {
            duration: ".5",
            delay: 0.5,
            attr: {
              opacity: 0,
            },
          });
        }
      });
    },
    bullet06() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-azul"), {
        duration: ".25",
        opacity: 1,
      });
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-mapa"), {
        duration: ".25",
        opacity: 1,
      });
      gsap.to(document.querySelector("#tubo-pattern"), {
        delay: 1.5,
        duration: ".5",
        attr: {
          height:
            this.alto_tubo_pattern_image /
            ((this.tamanios.alto * 72 * 0.7) / 100),
        },
      });

      var porcentajes = [72, 59, 46];
      this.escenas.escena_04.forEach((d, i) => {
        if (d.alias == "tubo") {
          gsap.to(this.tubos[i], {
            duration: ".5",
            delay: 0.5 + (i % 3) * 0.5,
            attr: {
              height: (this.tamanios.alto * porcentajes[i] * 0.7) / 100,
              y:
                this.tamanios.alto * 4.755 -
                (this.tamanios.alto * porcentajes[i] * 0.7) / 100,
            },
          });
        }

        if (d.alias == "pleca") {
          if (i % 3 == 0) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 0.5,
              attr: {
                y:
                  ((i % 2 == 1
                    ? 4.755 - (porcentajes[i % 3] * 0.7) / 100
                    : 4.755) -
                    0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 0,
              },
            });
          } else if (i % 3 == 1) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1,
              attr: {
                y:
                  ((i % 2 == 1
                    ? 4.755 - (porcentajes[i % 3] * 0.7) / 100
                    : 4.755) -
                    0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 0,
              },
            });
          } else if (i % 3 == 2) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1.5,
              attr: {
                y:
                  ((i % 2 == 1
                    ? 4.755 - (porcentajes[i % 3] * 0.7) / 100
                    : 4.755) -
                    0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 0,
              },
            });
          }
        }
      });
      this.escenas.escena_06.forEach((d, i) => {
        if (d.alias == "pleca") {
          if (i % 3 == 0) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 0.5,
              attr: {
                y:
                  ((i % 2 == 1
                    ? 4.755 - (porcentajes[i % 3] * 0.7) / 100
                    : 4.755) -
                    0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 1,
              },
            });
            if (i % 2 == 0) {
              this.txt_porcentaje_amarillo.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              this.txt_porcentaje_amarillo.setAttribute(
                "y",
                (4.755 - (porcentajes[i % 3] * 0.7) / 100) *
                  this.tamanios.alto -
                  20
              );
              this.txt_porcentaje_amarillo.style.fontSize = `${
                this.tamanios.ancho *
                0.03 *
                (this.tamanio_pantalla == "escritorio" ? 1 : 1.5)
              }px`;
              gsap.to(this.txt_porcentaje_amarillo, {
                duration: ".5",
                delay: 0.5,
                attr: {
                  opacity: 1,
                },
              });
            }
          } else if (i % 3 == 1) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1,
              attr: {
                y:
                  ((i % 2 == 1
                    ? 4.755 - (porcentajes[i % 3] * 0.7) / 100
                    : 4.755) -
                    0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 1,
              },
            });
            if (i % 2 == 0) {
              this.txt_porcentaje_rosa.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              this.txt_porcentaje_rosa.setAttribute(
                "y",
                (4.755 - (porcentajes[i % 3] * 0.7) / 100) *
                  this.tamanios.alto -
                  20
              );
              this.txt_porcentaje_rosa.style.fontSize = `${
                this.tamanios.ancho *
                0.03 *
                (this.tamanio_pantalla == "escritorio" ? 1 : 1.5)
              }px`;
              gsap.to(this.txt_porcentaje_rosa, {
                duration: ".5",
                delay: 1,
                attr: {
                  opacity: 1,
                },
              });
            }
          } else if (i % 3 == 2) {
            gsap.to(d.image, {
              duration: ".5",
              delay: 1.5,
              attr: {
                y:
                  ((i % 2 == 1
                    ? 4.755 - (porcentajes[i % 3] * 0.7) / 100
                    : 4.755) -
                    0.5 * d.alto_frac) *
                  this.tamanios.alto,
                opacity: 1,
              },
            });
            if (i % 2 == 0) {
              this.txt_porcentaje_azul.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              this.txt_porcentaje_azul.setAttribute(
                "y",
                (4.755 - (porcentajes[i % 3] * 0.7) / 100) *
                  this.tamanios.alto -
                  20
              );
              this.txt_porcentaje_azul.style.fontSize = `${
                this.tamanios.ancho *
                0.03 *
                (this.tamanio_pantalla == "escritorio" ? 1 : 1.5)
              }px`;
              gsap.to(this.txt_porcentaje_azul, {
                duration: ".5",
                delay: 1.5,
                attr: {
                  opacity: 1,
                },
              });
            }
          }
        } else if (d.alias == "flecha") {
          gsap.to(d.image, {
            duration: "1",
            delay: 0.5 * (1 + (i % 3)),

            attr: {
              opacity: 1,
              x: d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho,
              y: d.y_porc[this.tamanio_pantalla] * this.tamanios.alto,
              transform: `rotate(${0} 
                    ${d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho} 
                    ${
                      this.tamanios.alto *
                      (d.y_porc[this.tamanio_pantalla] +
                        (i % 3 == 0 ? d.alto_frac : 0))
                    })`,
            },
          });
        } else if (d.alias != "pleca" && d.alias != "flecha") {
          gsap.to(d.image, {
            duration: ".5",
            delay: 0.5 * (1 + (i % 3)),
            attr: {
              opacity: 1,
            },
          });
        }
      });
      this.escenas.escena_07.forEach((d, i) => {
        let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 3;

        if (d.alias == "casitas") {
          var edificio = this.escenas.escena_07.filter(
            (dd) => dd.alias == "edificios"
          )[0];
          gsap.to(d.image, {
            duration: "1",
            delay: 0.5,
            attr: {
              height: 0,
              y:
                edificio.y_porc[this.tamanio_pantalla] * this.tamanios.alto +
                0.5 * edificio.alto_frac * this.tamanios.ancho * factor_width,
            },
          });
        }
      });
    },
    bullet07() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-mapa"), {
        duration: ".25",
        opacity: 0,
      });
      this.escenas.escena_06.forEach((d, i) => {
        if (d.alias == "flecha") {
          gsap.to(d.image, {
            duration: "1",
            delay: 0.5,
            attr: {
              opacity: 0,
            },
          });
        }
      });
      this.escenas.escena_07.forEach((d, i) => {
        let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 3;

        if (d.alias == "casitas") {
          var edificio = this.escenas.escena_07.filter(
            (dd) => dd.alias == "edificios"
          )[0];

          gsap.to(d.image, {
            duration: "1",
            delay: 0.5,
            attr: {
              height: d.alto_frac * this.tamanios.ancho * factor_width,
              y:
                edificio.y_porc[this.tamanio_pantalla] * this.tamanios.alto +
                0.5 * edificio.alto_frac * this.tamanios.ancho * factor_width -
                d.alto_frac * this.tamanios.ancho * factor_width,
            },
          });
        }
        if (d.alias == "casitas" && d.image.href.animVal.includes("luces")) {
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
          gsap.to(d.image, {
            duration: "1.5",
            repeat: -1,
            yoyo: true,
            ease: "rough({ template: none.out, strength: 1, points: 20, taper: none, randomize: true, clamp: false})",
            attr: {
              opacity: 0.5,
            },
            scrollTrigger: {
              trigger: "#bullet-ciudades",
              start: "top bottom",
              toggleActions: "play pause play pause",
            },
          });
        }
        if (d.alias == "edificios" && d.image.href.animVal.includes("luces")) {
          gsap.set(d.image, {
            attr: {
              opacity: 0.2,
            },
          });
          gsap.to(d.image, {
            duration: "2",
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut",
            attr: {
              opacity: 1,
            },
            scrollTrigger: {
              trigger: "#bullet-ciudades",
              start: "top bottom",
              toggleActions: "play pause play pause",
            },
          });
        }
      });

      this.escenas.escena_08.forEach((d, i) => {
        if (d.alias == "fabrica") {
          gsap.to(d.image, {
            duration: ".25",
            attr: {
              height: 0,
              y: d.y_porc[this.tamanio_pantalla] * this.tamanios.alto,
            },
          });
        } else if (d.alias == "jet") {
          gsap.to(d.image, {
            duration: ".25",
            attr: {
              x: 1.5 * this.tamanios.ancho,
            },
          });
        } else if (d.alias == "camioneta") {
          gsap.to(d.image, {
            duration: ".25",
            attr: {
              x: -0.5 * this.tamanios.ancho,
            },
          });
        } else if (d.alias == "brazo") {
          gsap.to(d.image, {
            duration: ".25",
            ease: "bounce.out",
            attr: {
              y: 6 * this.tamanios.alto,
              opacity: 0,
            },
          });
        }
      });
    },
    bullet08() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-negro"), {
        duration: ".25",
        opacity: 0,
      });
     
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-azul"), {
        duration: ".25",
        opacity: 1,
      });
      this.escenas.escena_07.forEach((d, i) => {
        let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 3;

        if (d.alias == "casitas") {
          var edificio = this.escenas.escena_07.filter(
            (dd) => dd.alias == "edificios"
          )[0];

          gsap.to(d.image, {
            duration: "1",
            delay: 0.5,
            attr: {
              height: 0,
              y:
                edificio.y_porc[this.tamanio_pantalla] * this.tamanios.alto +
                0.5 * edificio.alto_frac * this.tamanios.ancho * factor_width,
            },
          });
        }
      });
      this.escenas.escena_08.forEach((d, i) => {
        let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 1.5;

        var fabrica = this.escenas.escena_08.filter(
          (dd) => dd.alias == "fabrica"
        )[0];

        if (d.alias == "fabrica") {
          gsap.to(d.image, {
            duration: "2",
            delay: 0,
            attr: {
              height: d.alto_frac * this.tamanios.ancho * factor_width,
              y:
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
                d.alto_frac * this.tamanios.ancho * factor_width,
            },
          });
        } else if (d.alias == "jet") {
          gsap.to(d.image, {
            duration: "1",
            delay: 0.25,
            attr: {
              x: d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho,
              y:
                fabrica.y_porc[this.tamanio_pantalla] * this.tamanios.alto +
                0.5 * fabrica.alto_frac * this.tamanios.ancho * factor_width -
                d.alto_frac * this.tamanios.ancho,
            },
          });
        } else if (d.alias == "camioneta") {
          gsap.to(d.image, {
            duration: "1",
            delay: 0.5,
            attr: {
              x: d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho,
            },
          });
        } else if (d.alias == "brazo") {
          gsap.to(d.image, {
            duration: "1.25",
            delay: 0.5,
            ease: "bounce.out",
            attr: {
              y: d.y_porc[this.tamanio_pantalla] * this.tamanios.alto,
              opacity: 1,
            },
          });
        }
      });
     
      if (this.texto_urgente) {
        this.texto_urgente.setAttribute("opacity", "0");
      }
    },
    bullet09() {
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-verde"), {
        duration: ".25",
        opacity: 0,
      });
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-azul"), {
        duration: ".25",
        opacity: 0,
      });
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-negro"), {
        duration: ".25",
        opacity: 1,
      });

      // Texto urgente
      this.texto_urgente
        ? this.grupo_principal.removeChild(this.texto_urgente)
        : null;
      this.texto_urgente = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "text"
      );
      this.grupo_principal.append(this.texto_urgente);
      this.texto_urgente.setAttribute("x", this.tamanios.ancho * 0.5);
      this.texto_urgente.setAttribute("y", 50 + this.tamanios.alto * 8.5);
      this.texto_urgente.setAttribute("fill", "#fff");
      this.texto_urgente.innerHTML = "Es urgente actuar";
      this.texto_urgente.style.textAnchor = "middle";
      this.texto_urgente.style.dominantBaseline = "text-after-edge";
      this.texto_urgente.style.fontSize = `calc(5vw + 16px)`;
      this.texto_urgente.style.fontWeight = `700`;
      gsap.to(this.texto_urgente, {
        duration: "3",
        opacity: 1,
      });

      for (var i = 0; i < 450; i++) {
        const circle = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "circle"
        );
        this.grupo_principal.append(circle);
        circle.setAttribute(
          "cx",
          this.tamanios.ancho * (0.3 + 0.4 * Math.random())
        );
        circle.setAttribute(
          "cy",
          this.tamanios.alto * (8.3 + 0.4 * Math.random())
        );
        circle.setAttribute("r", 0);
        circle.setAttribute(
          "fill",
          gsap.utils.random(["orange", "#424242", "#292929"])
        );

        gsap.to(circle, {
          cx: "+=random(-350,350)",
          cy: "+=random(-350,350)",
          opacity: 0,
          //ease: "rough({ template: power1.out, strength: 1, points: 50, taper: none, randomize: true, clamp: true})",
          duration: "random(1, 3)",
          delay: "random(0,1)",
          r: 100 + Math.random() * 200,
          onComplete: () => {
            this.grupo_principal.removeChild(circle);
          },
        });
      }
    },
    bullet10() {
      
      if (this.texto_urgente) {
        gsap.to(this.texto_urgente, {
          opacity: 0,
          duration: ".5",
        });
      }
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-negro"), {
        duration: ".25",
        opacity: 0,
      });
      gsap.to(document.querySelector("div.contenedor-fondo.fondo-verde"), {
        duration: ".25",
        opacity: 1,
      });
      var techo = this.escenas.escena_10.filter((dd) => dd.alias == "techo")[0];
      let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 1.5;
      this.escenas.escena_10.forEach((d, i) => {
        let dict_tiempos = {}
        // Estados iniciales
        if (d.alias == "hierba") {
          dict_tiempos[d.alias] = {duration: 1, delay: .5};
          gsap.set(d.image, {
            attr: {
              y: this.tamanios.alto * 8,
            },
          });
          
        } else if (d.alias == "bambu") {
          dict_tiempos[d.alias] = {duration: 1, delay: .5};
          gsap.set(d.image, {
            attr: {
              y: this.tamanios.alto * 11,
            },
          });
        } else if (d.alias == "planta_1") {
          dict_tiempos[d.alias] = {duration: .5, delay: .5};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "persona") {
          dict_tiempos[d.alias] = {duration: .5, delay: 1};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "presa") {
          dict_tiempos[d.alias] = {duration: 1.5, delay: 0};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "eolico") {
          dict_tiempos[d.alias] = {duration: 1, delay: 1};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "techo") {
          dict_tiempos[d.alias] = {duration: .25, delay: 0};

        } else if (d.alias == "grafica") {
          dict_tiempos[d.alias] = {duration: .25, delay: 0};

        } else if (d.alias == "calentador") {
          dict_tiempos[d.alias] = {duration: .8, delay: .8};
          gsap.set(d.image, {
            attr: {
              y: this.tamanios.alto * 11,
            },
          });
        } else if (d.alias == "planta_2") {
          dict_tiempos[d.alias] = {duration: 1, delay: .5};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "señor") {
          dict_tiempos[d.alias] = {duration: .5, delay: 1.2};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "señora") {
          dict_tiempos[d.alias] = {duration: .6, delay: .7};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "fogon") {
          dict_tiempos[d.alias] = {duration: .25, delay: 0};

        } else if (d.alias == "panel") {
          dict_tiempos[d.alias] = {duration: .8, delay: .8};
          gsap.set(d.image, {
            attr: {
              y: this.tamanios.alto * 11,
            },
          });
        } else if (d.alias == "bici") {
          dict_tiempos[d.alias] = {duration: .5, delay: .5};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
              x: .5 * this.tamanios.ancho
            },
          });
        } else if (d.alias == "planta_3") {
          dict_tiempos[d.alias] = {duration: .5, delay: 1};
          gsap.set(d.image, {
            attr: {
              opacity: 0,
            },
          });
        } else if (d.alias == "leña") {
          dict_tiempos[d.alias] = {duration: .25, delay: 0};

        }
        // Transiciones
        if(d.alias == "techo"){
          gsap.to(d.image, {
            duration: ".5",
            attr: {
              y: d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
              (1 * d.alto_frac * this.tamanios.ancho * factor_width) /
                factor_width
            },
          });
        }
        else{
          gsap.to(d.image, {
            duration: dict_tiempos[d.alias].duration,
            delay: dict_tiempos[d.alias].delay,
            attr: {
              opacity: 1,
              y:
                techo.y_porc[this.tamanio_pantalla] * this.tamanios.alto +
                d.y_porc[this.tamanio_pantalla] *
                  techo.alto_frac *
                  this.tamanios.ancho *
                  factor_width,
              x: d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
            },
          });
        }

        
      });
    },
    configurandoDimensionesLienzo() {
      this.tamanios.ancho =
        window.innerWidth > this.ancho_disenio
          ? this.ancho_disenio
          : window.innerWidth;
      this.tamanios.alto = window.innerHeight;

      this.lienzo.setAttribute("width", this.tamanios.ancho);
      this.lienzo.setAttribute("height", this.tamanios.alto);

      this.altura_narrativa = (this.steps.length + 0) * this.tamanios.alto;
    },
    configurandoMecha() {
      let coord_linea = (this.tamanio_pantalla == "escritorio" ? this.coordenadas_linea_escritorio : this.coordenadas_linea_movil)
      let path = `M${coord_linea[0][0] * this.tamanios.ancho} ${
        coord_linea[0][1] * this.tamanios.alto
      } `;
      for (var i = 1; i < coord_linea.length; i++) {
        path += `L${coord_linea[i][0] * this.tamanios.ancho} ${
          coord_linea[i][1] * this.tamanios.alto
        } `;
      }
      this.mecha.setAttribute("d", path);
      this.mecha.style.fill = "none";
      this.mecha.style.stroke = "#03036b";
      this.mecha.style.strokeWidth = "10px";

      this.mecha_len = this.mecha.getTotalLength();
      this.punto_actual_mecha = this.mecha.getPointAtLength(this.mecha_len);
    },
    configurandoLineasPunteadas() {
      // Linea 1
      let coord_path_1 = (this.tamanio_pantalla == "escritorio" ? this.coord_path_punteado_1_escritorio : this.coord_path_punteado_1_movil)

      let path = `M${coord_path_1[0][0] * this.tamanios.ancho} ${
        coord_path_1[0][1] * this.tamanios.alto
      } `;
      for (var i = 1; i < coord_path_1.length; i++) {
        path += `L${coord_path_1[i][0] * this.tamanios.ancho} ${
          coord_path_1[i][1] * this.tamanios.alto
        } `;
      }
      this.punteada_1.setAttribute("d", path);
      this.punteada_1.style.fill = "none";
      this.punteada_1.style.stroke = "#fff";
      this.punteada_1.style.strokeWidth = "3px";
      this.punteada_1.setAttribute("stroke-dasharray", "0 100000");

      // Linea 2
      let coord_path_2 = (this.tamanio_pantalla == "escritorio" ? this.coord_path_punteado_2_escritorio : this.coord_path_punteado_2_movil);

      path = `M${coord_path_2[0][0] * this.tamanios.ancho} ${
        coord_path_2[0][1] * this.tamanios.alto
      } `;
      for (var i = 1; i < coord_path_2.length; i++) {
        path += `L${coord_path_2[i][0] * this.tamanios.ancho} ${
          coord_path_2[i][1] * this.tamanios.alto
        } `;
      }
      this.punteada_2.setAttribute("d", path);
      this.punteada_2.style.fill = "none";
      this.punteada_2.style.stroke = "#fff";
      this.punteada_2.style.strokeWidth = "3px";
      this.punteada_2.setAttribute("stroke-dasharray", "0 100000");

      // Linea 3
      let coord_path_3 = (this.tamanio_pantalla == "escritorio" ? this.coord_path_punteado_3_escritorio : this.coord_path_punteado_3_movil);

      path = `M${coord_path_3[0][0] * this.tamanios.ancho} ${
        coord_path_3[0][1] * this.tamanios.alto
      } `;
      for (var i = 1; i < coord_path_3.length; i++) {
        path += `L${coord_path_3[i][0] * this.tamanios.ancho} ${
          coord_path_3[i][1] * this.tamanios.alto
        } `;
      }
      this.punteada_3.setAttribute("d", path);
      this.punteada_3.style.fill = "none";
      this.punteada_3.style.stroke = "#fff";
      this.punteada_3.style.strokeWidth = "3px";
      this.punteada_3.setAttribute("stroke-dasharray", "0 100000");
    },

    configurandoCapas() {
      for (var escena in this.escenas) {
        this.escenas[escena].forEach((d, i) => {
          if (d.ancho_original) {
            d.aspect = d.ancho_original / d.alto_original;
            d.ancho_frac = d.ancho_original / this.ancho_disenio;
            d.alto_frac = d.alto_original / this.ancho_disenio;
            d.image.setAttribute("preserveAspectRatio", "xMinYMid slice");
            d.image.setAttribute("width", d.ancho_frac * this.tamanios.ancho);
            d.image.setAttribute("height", d.alto_frac * this.tamanios.ancho);
            if (escena == "escena_00") {
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              d.image.setAttribute(
                "width",
                d.ancho_frac *
                  this.tamanios.ancho *
                  (this.tamanio_pantalla == "escritorio" ? 1 : 1.5)
              );
              d.image.setAttribute(
                "height",
                d.alto_frac *
                  this.tamanios.ancho *
                  (this.tamanio_pantalla == "escritorio" ? 1 : 1.5)
              );
            } else if (escena == "escena_01") {
              let factor_width =
                this.tamanio_pantalla == "escritorio" ? 1 : 1.8;
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
                  0.5 * d.alto_frac * this.tamanios.ancho * factor_width
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho -
                  0.5 * d.alto_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
            } else if (escena == "escena_02") {
              let factor_width =
                this.tamanio_pantalla == "escritorio" ? 1 : 1.5;

              d.image.setAttribute(
                "y",
                (d.y_porc[this.tamanio_pantalla] + 1) * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
            } else if (escena == "escena_03") {
              let factor_width =
                this.tamanio_pantalla == "escritorio" ? 1 : 1.5;

              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              d.image.setAttribute("opacity", 0);
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
            } else if (escena == "escena_04") {
              let factor_width =
                this.tamanio_pantalla == "escritorio" ? 1 : 1.5;
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              if (d.alias != "tubo" && d.alias != "pleca") {
                d.image.setAttribute(
                  "y",
                  parseInt(Math.round((i - 4) / 3)) != 0
                    ? d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
                    : d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
                        d.alto_frac *
                          this.tamanios.ancho *
                          (this.tamanio_pantalla == "escritorio"
                            ? 1
                            : factor_width)
                );
                d.image.setAttribute(
                  "x",
                  (d.x_porc[this.tamanio_pantalla] -
                    0.5 *
                      d.ancho_frac *
                      (this.tamanio_pantalla == "escritorio"
                        ? 1
                        : factor_width)) *
                    this.tamanios.ancho
                );
                // );
              } else if (d.alias == "tubo") {
                d.image.setAttribute("opacity", 0); // );
              } else if (d.alias == "pleca") {
                d.image.setAttribute(
                  "x",
                  (d.x_porc[this.tamanio_pantalla] -
                    0.5 *
                      d.ancho_frac *
                      (this.tamanio_pantalla == "escritorio"
                        ? 1
                        : factor_width)) *
                    this.tamanios.ancho
                );
              } else {
                d.image.setAttribute(
                  "y",
                  d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
                ); // );
              }
            } else if (escena == "escena_06") {
              let factor_width =
                this.tamanio_pantalla == "escritorio" ? 1 : 1.5;
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                (d.x_porc[this.tamanio_pantalla] -
                  0.5 *
                    d.ancho_frac *
                    (this.tamanio_pantalla == "escritorio"
                      ? 1
                      : factor_width)) *
                  this.tamanios.ancho
              );

              if (d.alias != "flecha") {
                d.image.setAttribute("opacity", 0); // );
              } else if (d.alias != "pleca") {
                d.image.setAttribute("opacity", 0); // );
              } else if (d.alias == "flecha") {
                d.image.setAttribute(
                  "x",
                  this.tamanios.ancho * (parseInt((i - 9) / 3) < 1 ? -0.2 : 1.2)
                );
                var angs = [-30, 45, 90];

                d.image.setAttribute(
                  "transform",
                  `rotate(
                ${(parseInt((i - 9) / 3) < 1 ? -1 : 1) * angs[i % 3]} 
                ${d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho} 
                ${
                  this.tamanios.alto *
                  (d.y_porc[this.tamanio_pantalla] +
                    (i % 3 == 0 ? d.alto_frac : 0))
                }
              )`
                );
              }
            } else if (escena == "escena_07") {
              let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 3;

              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              var edificio = this.escenas.escena_07.filter(
                (dd) => dd.alias == "edificios"
              )[0];
              if (edificio.ancho_original) {
                d.image.setAttribute(
                  "width",
                  d.ancho_frac * this.tamanios.ancho * factor_width
                );
                d.image.setAttribute(
                  "height",
                  d.alto_frac * this.tamanios.ancho * factor_width
                );

                if (d.alias == "casitas") {
                  d.image.setAttribute(
                    "y",
                    edificio.y_porc[this.tamanio_pantalla] *
                      this.tamanios.alto +
                      0.5 *
                        edificio.alto_frac *
                        this.tamanios.ancho *
                        factor_width
                  ); // );

                  d.image.setAttribute("height", 0);
                  d.image.setAttribute("preserveAspectRatio", "xMidYMin slice");
                } else if (d.alias == "edificios") {
                  d.image.setAttribute(
                    "y",
                    d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
                      0.5 * d.alto_frac * this.tamanios.ancho * factor_width
                  ); // );
                  d.image.setAttribute("preserveAspectRatio", "xMidYMin slice");
                } else if (d.alias == "helicoptero") {
                  d.image.setAttribute(
                    "y",
                    edificio.y_porc[this.tamanio_pantalla] *
                      this.tamanios.alto -
                      0.45 *
                        edificio.alto_frac *
                        this.tamanios.ancho *
                        factor_width
                  ); // );
                }
              }
            } else if (escena == "escena_08") {
              let factor_width =
                this.tamanio_pantalla == "escritorio" ? 1 : 1.5;
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              if (d.alias == "fabrica") {
                d.image.setAttribute("height", 0);
                d.image.setAttribute("preserveAspectRatio", "xMidYMin slice");
              } else if (d.alias == "jet") {
                d.image.setAttribute("x", 1.5 * this.tamanios.ancho);
              } else if (d.alias == "camioneta") {
                d.image.setAttribute("x", -0.5 * this.tamanios.ancho);
              } else if (d.alias == "brazo") {
                d.image.setAttribute("y", 6 * this.tamanios.alto);
                d.image.setAttribute("opacity", 0);
                d.image.setAttribute(
                  "width",
                  d.ancho_frac *
                    this.tamanios.ancho *
                    (this.tamanio_pantalla == "escritorio"
                      ? 1
                      : factor_width * 1.2)
                );
                d.image.setAttribute(
                  "height",
                  d.alto_frac *
                    this.tamanios.ancho *
                    (this.tamanio_pantalla == "escritorio"
                      ? 1
                      : factor_width * 1.2)
                );
              }
            } else if (escena == "escena_10") {
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
              d.image.setAttribute(
                "x",
                d.x_porc[this.tamanio_pantalla] * this.tamanios.ancho
              );
              d.image.setAttribute("preserveAspectRatio", "xMidYMin slice");
              let factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 2;
              d.image.setAttribute(
                "width",
                d.ancho_frac * this.tamanios.ancho * factor_width
              );
              d.image.setAttribute(
                "height",
                d.alto_frac * this.tamanios.ancho * factor_width
              );
              var techo = this.escenas.escena_10.filter(
                (dd) => dd.alias == "techo"
              )[0];
              if (techo.alto_frac) {
                if (d.alias == "techo") {
                  d.image.setAttribute(
                    "y",
                    d.y_porc[this.tamanio_pantalla] * this.tamanios.alto -
                      (1 * d.alto_frac * this.tamanios.ancho * factor_width) /
                        factor_width
                  );
                  d.image.setAttribute(
                    "width",
                    (d.ancho_frac * this.tamanios.ancho * factor_width) /
                      factor_width
                  );
                  d.image.setAttribute(
                    "height",
                    (d.alto_frac * this.tamanios.ancho * factor_width) /
                      factor_width
                  );
                } else {
                  d.image.setAttribute(
                    "y",
                    techo.y_porc[this.tamanio_pantalla] * this.tamanios.alto +
                      d.y_porc[this.tamanio_pantalla] *
                        techo.alto_frac *
                        this.tamanios.ancho *
                        factor_width
                  );
                }
              }
            } else {
              d.image.setAttribute(
                "y",
                d.y_porc[this.tamanio_pantalla] * this.tamanios.alto
              ); // );
            }
          }
        });
      }
    },
    configurandoTubos() {
      var factor_width = this.tamanio_pantalla == "escritorio" ? 1 : 1.5;
      this.ancho_tubo_pattern_image = this.tamanios.ancho * 0.1 * factor_width;
      this.alto_tubo_pattern_image =
        (this.ancho_tubo_pattern_image * 759) / 141;
      document
        .querySelector("svg defs pattern#tubo-pattern image")
        .setAttribute("width", this.ancho_tubo_pattern_image);
      document
        .querySelector("svg defs pattern#tubo-pattern image")
        .setAttribute("height", (this.ancho_tubo_pattern_image * 759) / 141);

      for (var i = 0; i < 3; i++) {
        this.tubos[i].setAttribute(
          "x",
          (0.2 + 0.3 * i) * this.tamanios.ancho -
            0.5 * this.ancho_tubo_pattern_image
        );
        this.tubos[i].setAttribute("y", 3.5 * this.tamanios.alto);
        this.tubos[i].setAttribute("width", this.ancho_tubo_pattern_image);
        this.tubos[i].setAttribute("height", 0);
      }
    },
    creaChispa(point) {
      const circle = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle"
      );
      this.grupo_principal.prepend(circle);
      circle.setAttribute("cx", point.x);
      circle.setAttribute("cy", point.y);
      circle.setAttribute("r", 4 + Math.random() * 7);
      circle.setAttribute(
        "fill",
        gsap.utils.random(["orange", "#424242", "#292929"])
      );

      gsap.to(circle, {
        cx: "+=random(-20,20)",
        cy: "+=random(-20,20)",
        opacity: 0.1,
        duration: "random(.3, .7)",
        autoRound: false,
        onComplete: () => {
          this.grupo_principal.removeChild(circle);
        },
      });
    },
    reescalado() {
      this.tamanio_pantalla = 768 < window.innerWidth ? "escritorio" : "movil";
      this.configurandoDimensionesLienzo();
      this.configurandoMecha();
      this.configurandoLineasPunteadas();
      this.configurandoTubos();
      this.configurandoCapas();
      this.seccion_actual = null;
      this.escroleando();
      
    },
    escroleando() {
      // Comienza escroledo
      let scroll_y = window.scrollY;

      this.mecha.setAttribute(
        "stroke-dasharray",
        `${this.mecha.getTotalLength()} ${this.mecha.getTotalLength()}`
      );

      let coord;

      const newSection = parseInt((this.scroll_y + 85) / this.tamanios.alto);

      //if (newSection < 2) {
      this.mecha.setAttribute(
        "stroke-dashoffset",
        -this.mecha.getTotalLength() *
          (scroll_y / (this.altura_narrativa - 2 * this.tamanios.alto))
      );
      coord = this.mecha.getPointAtLength(
        this.mecha.getTotalLength() *
          (scroll_y / (this.altura_narrativa - 2 * this.tamanios.alto))
      );
      //}
      /*else if (newSection >= 2) {
        console.log("secc2");
        this.mecha.setAttribute(
          "stroke-dashoffset",
          -this.mecha.getTotalLength() *
            ((1.1 * this.tamanios.alto + 0.5 * scroll_y) /
              this.altura_narrativa)
        );
        coord = this.mecha.getPointAtLength(
          this.mecha.getTotalLength() *
            ((1.1 * this.tamanios.alto + 0.5 * scroll_y) /
              this.altura_narrativa)
        );
      }*/

      if (scroll_y > this.scroll_y) {
        this.creaChispa(coord);
      }
      this.scroll_y = scroll_y;

      if (newSection !== this.seccion_actual) {
        if (newSection == 0) {
          gsap.to(this.grupo_principal, {
            y: 0,
            duration: "1",
          });
          this.bullet00();
        }
        if (newSection == 1) {
          gsap.to(this.grupo_principal, {
            y: -1 * (this.altura_narrativa / this.steps.length),
            duration: "1",
          });
          this.bullet01();
        }
        if (newSection == 2) {
          gsap.to(this.grupo_principal, {
            y: -2 * (this.altura_narrativa / this.steps.length),
            duration: "1",
          });
          this.bullet02();
        }
        if (newSection == 3) {
          gsap.to(this.grupo_principal, {
            y: -2 * (this.altura_narrativa / this.steps.length),
            duration: "1",
          });
          this.bullet03();
        }
        if (newSection == 4) {
          gsap.to(this.grupo_principal, {
            y: -3 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          this.bullet04();
        }
        if (newSection == 5) {
          gsap.to(this.grupo_principal, {
            y: -4 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          this.bullet05();
        }
        if (newSection == 6) {
          gsap.to(this.grupo_principal, {
            y: -4 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          this.bullet06();
        }
        if (newSection == 7) {
          gsap.to(this.grupo_principal, {
            y: -5 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          this.bullet07();
        }
        if (newSection == 8) {
          gsap.to(this.grupo_principal, {
            y: -6 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          this.bullet08();
        }

        if (newSection == 9) {
          // Este bullet de explosion tiene doble espaciado de los vecinos para que no se encimen los círculos con los vecinos
          gsap.to(this.grupo_principal, {
            y: -8 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          this.bullet09();
        }
        if (newSection == 10) {
          gsap.to(this.grupo_principal, {
            y: -10 * (this.altura_narrativa / this.steps.length),
            duration: ".5",
          });
          if(this.seccion_actual < 10) {this.bullet10();}
        }

        this.seccion_actual = newSection;

        // console.log("cambio", this.seccion_actual);
      }
      // Degradado

      var y_bullet_1 = 1 - this.scroll_y / this.tamanios.alto;
      this.y_scrolleado_normalizado = (-y_bullet_1 + 1) / this.steps.length;
      //console.log(this.y_scrolleado_normalizado);

      var alpha = 1 - this.y_scrolleado_normalizado / this.steps.length;
      this.steps[0].style.background =
        "linear-gradient(transparent,rgba(0,0,0," + y_bullet_1 + "))";
      this.steps[1].style.background =
        "linear-gradient(rgba(0,0,0," + y_bullet_1 + "),transparent)";
    },

    animacion() {
      const elapsedTime = this.clock.getElapsedTime();
      const deltaTime = elapsedTime - this.previousTime;
      this.previousTime = elapsedTime;

      // Render
      this.renderer.render(this.scene, this.camera);
      //Linea
      this.fraction = (this.fraction + 0.001) % 1; // fraction in [ 0, 1 ]
      this.line.material.dashSize = this.fraction * this.lineLength;
      // Call tick again on the next frame
      window.requestAnimationFrame(this.animacion);
    },
  },
};
</script>
    
    
   



<style  lang="scss">

div.fondo-narrativa {
  z-index: -1;
  div.contenedor-svg {
    display: flex;
    svg.lienzo {
      position: relative;
      margin: 0 auto;
      outline: none;
    }
  }

  //position: -webkit-sticky;
  position: sticky;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  z-index: 0;
  height: 100vh;
  top: 0;
  width: 100%;
  left: 0;
  //display: flex;
  div.contenedor-fondo {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    opacity: 0;
    transition: all 0.5s;
    overflow: hidden;
    &:nth-child(1) {
      opacity: 1;
    }
    .capa {
      transition: all 2s;
      width: 100%;
      height: 100%;
      position: absolute;
    }
    img {
      position: absolute;
      width: 100%;
      max-width: 100%;
      height: 100%;
      left: 0;
      object-fit: cover;
      object-position: center;
    }
    &.fondo-negro{
      background: #000;
    }
  }
}
article {
  top: -100vh;
  position: relative;
  div.step:first-of-type {
    background: linear-gradient(transparent, rgba(0, 0, 0, 1));
  }
  div.step {
    height: 100vh;
    position: relative;
    display: flex;
    .cover {
      background: transparent;
    }
    .cover-gradient {
      background: none;
    }
    .bullet {
      display: flex;
      background: rgba(255, 255, 255, 0.95);
      color: #094f3c;
      position: relative;
      max-width: 400px;
      margin-top: auto;
      margin-right: auto;
      margin-left: auto;
      padding: 16px;
      &.urgente {
        background: transparent;
      }
      @media (min-width: 768px) {
        margin-right: auto;
        margin-left: auto;
      }
    }
  }
}
.lil-gui.autoPlace {
  z-index: 1000000;
}
</style>
    